import { render, staticRenderFns } from "./ImprovedSurveyList.vue?vue&type=template&id=c8ac15e6&"
import script from "./ImprovedSurveyList.vue?vue&type=script&lang=js&"
export * from "./ImprovedSurveyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports